<template>
  <v-card class="mb-5 stik-header">
    <v-skeleton-loader class="my-5" type="list-item-avatar-two-line" v-if="!customer" />

    <v-list-item v-else>
      <v-list-item-avatar color="grey">
        <img v-if="customer.avatar" :src="customer.avatar" class="med-card__avatar" style="object-fit: cover;" />
        <img v-else src="@/assets/img/avatar5.png" class="med-card__avatar" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="headline">
          {{ customer.last_name }} {{ customer.first_name }} {{ customer.middle_name
          }}<span v-if="customer.phone"
            >, <a :href="`tel:${customer.phone}`">{{ customer.phone }}</a></span
          ><span v-if="customer.dms">, ДМС: {{ customer.dms }}</span>
          <v-checkbox
            :input-value="customer.pd_consent"
            label="ПД - согласие предоставлено"
            class="d-inline-flex mt-0 ml-4"
            dense
            hide-details
            disabled
          ></v-checkbox>
        </v-list-item-title>

        <v-list-item-subtitle>
          <span v-if="customer.age"
            >{{ birthday }} ({{ customer.age }} {{ $utils.pluralForm(customer.age, ["год", "года", "лет"]) }})</span
          >,
          {{ customer.organization.full_name }}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          Занятость: {{ customer.is_employed === null || customer.is_employed === undefined ? "Нет данных" : customer.is_employed ? "Работает" : "Уволен" }}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="showDetails">
          <div v-if="customer.structure">{{ customer.structure }}, {{ customer.position }}</div>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-btn elevation="1" v-if="canEditPatients" fab small class="mr-2" color="white" @click="editPatient()">
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn elevation="1" fab small @click="toggle()" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </v-list-item>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import AddPatient from "@/modules/patients/components/AddPatient.vue";

import { mapState } from "vuex";

export default {
  name: "PatientHeader",
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    toggle() {
      this.showDetails = !this.showDetails;
    },
    async editPatient() {
      console.log(`this.customer =>`, this.customer);
      const res = await this.$dialog.showAndWait(AddPatient, { width: "600px", patient: this.customer, persistent: true });
      if (res) {
        await this.$store.dispatch("customer/loadProfile", this.$store.state.customer.id);
      }
    },
  },
  computed: {
    ...mapState("auth", ["profile"]),

    canEditPatients() {
      return typeof this.profile.schedule_editor_flag === "undefined" || this.profile.can_edit_patients;
    },
    customer() {
      return this.$store.state.customer.profile;
    },
    birthday() {
      if (this.customer) {
        return dayjs(this.customer.birthday).format("DD.MM.YYYY");
      }
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
.stik-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 200;
}
</style>
